import type { MonsterTokenStyle } from '../api';

export const getInvestigatorArtworkPath = (name: string, preview = true) =>
  `/Investigators/tokens/rework/${preview ? 'small/' : ''}${encodeURIComponent(name)}.jpg`;

export const getInvestigatorTokenImagePath = (name: string, style: MonsterTokenStyle) =>
  style === 'Digital'
    ? getInvestigatorArtworkPath(name)
    : `/Investigators/tokens/${encodeURIComponent(name)}.jpg`;
